import 'angular:locale/data:nb';
import '@angular/localize/init';
import 'zone.js';(globalThis.$localize ??= {}).locale = "nb";
